export default {
  "home": "ДОМОЙ",
  "news": "НОВОСТИ",
  "community": "СООБЩЕСТВО",
  "character": "ПЕРСОНАЖИ",
  "world": "НАСТРОЙКИ МИРА",
  "features": "ФУНКЦИИ",
  "topUp": "ПОПОЛНЕНИЕ",
  "customerService": "СЛУЖБА ПОДДЕРЖКИ",
  "download": "СКАЧАТЬ",
  "moreDownload": "Другие способы загрузки",
  "screenshot": "СКРИНШОТ",
  "video": "СИНЕМАТИК",
  "poster": "ПЛАКАТ",
  "downloadGame": "СКАЧАТЬ",
  "scan": "Отсканируйте QR-код, чтобы скачать",
  "prev": "Пред.",
  "next": "След.",
  "moreNews": "ИНФОРМАЦИЯ",
  "latest": "НОВИНКИ",
  "fwtk": "TERMS OF SERVICE",
  "yszc": "PRIVACY POLICY",
  "noContent": "Пока нет содержания",
  "goPay": "ВПЕРЁД",
  "payGuide": "УЗНАТЬ БОЛЬШЕ",
  "stayTurn": "Пока нет содержания",
  "hero1": "Ричард",
  "hero1_text": "Ричард I, также известный как Ричард Львиное Сердце, стал королем Англии 6 июля 1189 года. За годы своего правления он снискал славу великого военачальника и бесстрашного воина.",
  "hero1_skill1": "Король Крестоносцев",
  "hero1_skill2": "Королевская Гвардия",
  "hero1_skill3": "Львиное Сердце",
  "hero1_skill4": "Заряд Энергии",
  "hero2": "Александр Македонский",
  "hero2_text": "Александр Македонский, он же Александр III Великий, — царь Древней Македонии, выдающийся полководец и создатель мировой державы. В стремлении достичь «края света и Великого внешнего моря» он прошел множество войн не проиграл ни одной битвы.",
  "hero2_skill1": "Сын Божий",
  "hero2_skill2": "Сподвижники",
  "hero2_skill3": "Одинокий Марш",
  "hero2_skill4": "Македонская Фаланга",
  "hero3": "Мулань",
  "hero3_text": "Хуа Мулань - легендарная народная героиня эпохи Северных и Южных Династий (4-6 века нашей эры) китайской истории. Согласно поэме «Песнь о Мулань», она переоделась в мужчину и пошла на войну вместо своего престарелого отца.",
  "hero3_skill1": "Мощный Выстрел",
  "hero3_skill2": "Народная Героиня",
  "hero3_skill3": "Долг Зовёт",
  "hero3_skill4": "Защитница Страны",
  "hero4": "Королева Сондок",
  "hero4_text": "Королева Сондок правила Силлой, одним из Трех корейских государств, с 632 по 647 год. Она стала двадцать седьмой правительницей Силлы и первой в истории Кореи царствующей королевой.",
  "hero4_skill1": "Благосклонность",
  "hero4_skill2": "Сообразительность",
  "hero4_skill3": "Завоевательница",
  "hero4_skill4": "Амнистия",
  "hero5": "Нобунага",
  "hero5_text": "Ода Нобунага (23 июня 1534 – 21 июня 1582) был японским даймё и одной из ведущих фигур периода Сэнгоку. Он посвятил жизнь объединению страны и стал одним из трех великих объединителей Японии, наряду со своими союзниками Тоётоми Хидэёси и Токугавой Иэясу.",
  "hero5_skill1": "Тэнка Фубу",
  "hero5_skill2": "Барьер",
  "hero5_skill3": "Цубаме Гаэси",
  "hero5_skill4": "Бусидо",
  "hero6": "Жанна д’Арк",
  "hero6_text": "Жанна д'Арк — святая покровительница Франции и защитница французской нации. Благодаря своему божественному предназначению она смогла выйти за рамки гендерных ролей, переломить ход войны и стать спасительницей родины.",
  "hero6_skill1": "Благословение Ангела",
  "hero6_skill2": "Жанна",
  "hero6_skill3": "Убеждение",
  "hero6_skill4": "Святая Обитель",
  "roleMainTitle": "Нанимайте легендарных героевa",
  "roleSubTitle": "В игре Game of Empires можно нанять целый ряд легендарных исторических личностей, которые помогут вам расширить вашу империю.",
  "back": "Назад",
  "slogan": "Постройте свою империю",
}
